import { Input } from '@presentation/components/molecules'
import { DateInputProps } from '@presentation/types/components/molecules'

const DateInput: React.FC<DateInputProps> = ({ ...rest }) => {
  return <Input type="date" {...rest} />
}

export default DateInput
